import React from 'react'

function Collapse(props) {
  return (
    <button type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target={props.target || "#navbar-collapse"}
            aria-expanded="false">
      <span className="sr-only">Toggle navigation</span>
      <span className="icon-bar"> </span>
      <span className="icon-bar"> </span>
      <span className="icon-bar"> </span>
    </button>
  )
}

export default Collapse


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/header/collapse/index.js